import React, { useContext, useRef, useEffect } from "react";
import ProductContext from "../../context/products/ProductContext";

const ProductFilter = () => {
  const productContext = useContext(ProductContext);
  const text = useRef("");

  const { filterProducts, clearFilter, filtered } = productContext;

  useEffect(() => {
    if (filtered === null) {
      text.current.value = "";
    }
  });
  const onChange = (e) => {
    if (text.current.value !== "") {
      filterProducts(e.target.value.replace(/[^\w\s]/gi, ""));
    } else {
      clearFilter();
    }
  };

  return (
    <form>
      <div
        className="input-group input-group-sm mb-3"
        style={{
          paddingTop: "10px",
        }}
      >
        <input
          className="form-control"
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-sm"
          ref={text}
          type="text"
          placeholder="Search Products"
          onChange={onChange}
        />{" "}
      </div>{" "}
    </form>
  );
};

export default ProductFilter;
